/** Where a figure or a document came from: Uploaded, Manual, Imported or Connector - ADR-0212
 * decision 10.
 *
 * The **Source** column of every data table. It is derived on read from how the row arrived and is
 * never stored, so this component only draws the server's word: it has no way to decide an origin.
 * A shape and a word, never colour alone (design rule 4): every origin has its own glyph.
 */

import { FileArrowUp, PencilSimple, PlugsConnected, Table } from "@phosphor-icons/react";
import type { Icon } from "@phosphor-icons/react";

import { StatusChip } from "./StatusChip";

export const ORIGINS = ["uploaded", "manual", "imported", "connector"] as const;
export type Origin = (typeof ORIGINS)[number];

const WORD: Record<Origin, string> = {
  uploaded: "Uploaded",
  manual: "Manual",
  imported: "Imported",
  connector: "Connector",
};

const GLYPH: Record<Origin, Icon> = {
  uploaded: FileArrowUp,
  manual: PencilSimple,
  imported: Table,
  connector: PlugsConnected,
};

export function isOrigin(value: string): value is Origin {
  return (ORIGINS as readonly string[]).includes(value);
}

export function originWord(origin: Origin): string {
  return WORD[origin];
}

export function SourceChip({ origin }: { origin: Origin }) {
  return (
    <StatusChip tone="neutral" size="sm" icon={GLYPH[origin]} testId={`source-${origin}`}>
      {WORD[origin]}
    </StatusChip>
  );
}
